import React from "react";
import "./Faq.css";
import faqImage from "../images/faq_graphic.jpg";

export default function Faq() {
  return (
    <section className="faq-section section-padding" id="section_4">
      <div className="container">
        <div className="row">
          <h2 className="">Frequently Asked Questions</h2>
          <div className="clearfix" />
          <div className="col-lg-5 col-12">
            <img src={faqImage} className="img-fluid" alt="FAQs" />
          </div>
          <div className="col-lg-6 col-12 m-auto">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                  Q1: How can Currency Growth Financial Services help me achieve my financial goals?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  A: Currency Growth Financial Services is dedicated to helping clients achieve their financial objectives through{" "}
                    <strong>
                    strategic planning and personalized investment strategies.
                    </strong>{" "}
                    Our team of financial experts assesses your unique financial situation, risk tolerance, and goals to develop a tailored plan that aims for currency growth and long-term financial success.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                  Q2: What financial services does Currency Growth Financial Services provide?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  A: Currency Growth Financial Services offers a range of solutions, including wealth management, investment planning, savings accounts, competitive loan options, and personalized financial advisory services to help you achieve your goals.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                  Q3: How does Currency Growth Financial Services stay informed about market trends and currency fluctuations?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  A: Our team of financial analysts and currency experts utilizes cutting-edge technology and in-depth market research to stay informed about global economic trends and currency fluctuations. We continuously monitor market conditions, geopolitical events, and economic indicators to provide timely insights and make informed investment decisions on behalf of our clients.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                  Q4: What sets Currency Growth Financial Services apart from other financial advisory firms?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  A: Currency Growth distinguishes itself through a client-centric approach, personalized service, and a commitment to transparency. Our experienced financial advisors prioritize understanding your individual goals and financial situation, ensuring that our strategies align with your objectives. We pride ourselves on clear communication, ethical practices, and a results-driven focus to help you achieve currency growth and financial prosperity.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
